import { render } from "./ImageQuestion.vue?vue&type=template&id=45b43bba"
import script from "./ImageQuestion.vue?vue&type=script&lang=js"
export * from "./ImageQuestion.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__